// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-location-card {
  background: linear-gradient(135deg, var(--bg-card) 0%, var(--bg-secondary) 100%);
  border-radius: var(--radius-lg);
  border: 2px solid var(--border-color);
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  transition: all var(--transition-normal);
  cursor: pointer;
  overflow: hidden;
}

.tv-location-card:hover {
  border-color: var(--accent-blue);
  transform: translateY(-4px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.tv-location-card.active {
  border-color: var(--accent-blue);
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, var(--bg-secondary) 100%);
}

/* Size Variations */
.tv-location-card.large {
  padding: var(--spacing-xl);
}

.tv-location-card.medium {
  padding: var(--spacing-md);
}

.tv-location-card.compact {
  padding: var(--spacing-md);
}

/* Loading State */
.tv-location-card.loading {
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.tv-card-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  color: var(--text-muted);
}

.tv-card-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent-blue);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Header */
.tv-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-lg);
}

.tv-card-location {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  color: var(--accent-blue);
}

.tv-card-location-text {
  display: flex;
  flex-direction: column;
}

.tv-card-city {
  font-size: 2rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.2;
}

.tv-location-card.medium .tv-card-city {
  font-size: 1.3rem;
}

.tv-location-card.compact .tv-card-city {
  font-size: 1.1rem;
}

.tv-card-country {
  font-size: 1rem;
  color: var(--text-muted);
}

.tv-location-card.compact .tv-card-country {
  font-size: 0.8rem;
}

.tv-card-times {
  display: flex;
  gap: var(--spacing-lg);
}

.tv-card-sun {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--text-secondary);
  font-size: 0.9rem;
}

/* Main Weather */
.tv-card-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: var(--spacing-xl);
}

.tv-location-card.compact .tv-card-main {
  margin-bottom: var(--spacing-md);
}

.tv-card-temp-section {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.tv-card-icon {
  width: 150px;
  height: 150px;
}

.tv-location-card.medium .tv-card-icon {
  width: 70px;
  height: 70px;
}

.tv-location-card.compact .tv-card-icon {
  width: 60px;
  height: 60px;
}

.tv-card-temp-info {
  display: flex;
  flex-direction: column;
}

.tv-card-temp {
  font-size: 6rem;
  font-weight: 200;
  color: var(--text-primary);
  line-height: 1;
}

.tv-location-card.medium .tv-card-temp {
  font-size: 3rem;
}

.tv-location-card.compact .tv-card-temp {
  font-size: 2.5rem;
}

.tv-card-temp-unit {
  font-size: 2rem;
  color: var(--text-secondary);
  vertical-align: top;
}

.tv-location-card.medium .tv-card-temp-unit {
  font-size: 1.5rem;
}

.tv-location-card.compact .tv-card-temp-unit {
  font-size: 1rem;
}

.tv-card-feels {
  font-size: 1.2rem;
  color: var(--text-muted);
  margin-top: var(--spacing-sm);
}

.tv-location-card.compact .tv-card-feels {
  font-size: 0.8rem;
}

.tv-card-condition {
  font-size: 1.5rem;
  color: var(--text-secondary);
  text-transform: capitalize;
  margin-top: var(--spacing-md);
}

.tv-location-card.medium .tv-card-condition {
  font-size: 1.2rem;
}

.tv-location-card.compact .tv-card-condition {
  font-size: 0.9rem;
  margin-top: var(--spacing-xs);
}

/* Metrics */
.tv-card-metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-md);
  padding: var(--spacing-lg);
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-lg);
}

.tv-location-card.medium .tv-card-metrics {
  grid-template-columns: repeat(2, 1fr);
  padding: var(--spacing-sm);
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-sm);
}

.tv-location-card.medium .tv-metric-value {
  font-size: 0.95rem;
}

.tv-location-card.medium .tv-card-main {
  margin-bottom: var(--spacing-md);
}

.tv-metric {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  color: var(--text-secondary);
}

.tv-metric-info {
  display: flex;
  flex-direction: column;
}

.tv-metric-value {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--text-primary);
}

.tv-location-card.medium .tv-metric-value {
  font-size: 1.1rem;
}

.tv-metric-label {
  font-size: 0.8rem;
  color: var(--text-muted);
}

/* Compact Metrics */
.tv-card-compact-metrics {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  font-size: 0.85rem;
  color: var(--text-secondary);
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--border-color);
}

.tv-card-compact-metrics span {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

/* Mini Forecast */
.tv-card-mini-forecast {
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-md);
  padding: var(--spacing-lg);
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--radius-md);
}

.tv-mini-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs);
  flex: 1 1;
}

.tv-mini-day-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.tv-mini-icon {
  width: 50px;
  height: 50px;
}

.tv-mini-temps {
  display: flex;
  gap: var(--spacing-sm);
  font-size: 1rem;
}

.tv-mini-high {
  font-weight: 600;
  color: var(--text-primary);
}

.tv-mini-low {
  color: var(--text-muted);
}`, "",{"version":3,"sources":["webpack://./src/components/TV/TVLocationCard.css"],"names":[],"mappings":"AAAA;EACE,gFAAgF;EAChF,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,yFAAyF;AAC3F;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".tv-location-card {\n  background: linear-gradient(135deg, var(--bg-card) 0%, var(--bg-secondary) 100%);\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--border-color);\n  padding: var(--spacing-xl);\n  display: flex;\n  flex-direction: column;\n  transition: all var(--transition-normal);\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.tv-location-card:hover {\n  border-color: var(--accent-blue);\n  transform: translateY(-4px);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n.tv-location-card.active {\n  border-color: var(--accent-blue);\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, var(--bg-secondary) 100%);\n}\n\n/* Size Variations */\n.tv-location-card.large {\n  padding: var(--spacing-xl);\n}\n\n.tv-location-card.medium {\n  padding: var(--spacing-md);\n}\n\n.tv-location-card.compact {\n  padding: var(--spacing-md);\n}\n\n/* Loading State */\n.tv-location-card.loading {\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.tv-card-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-md);\n  color: var(--text-muted);\n}\n\n.tv-card-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--accent-blue);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Header */\n.tv-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-lg);\n}\n\n.tv-card-location {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  color: var(--accent-blue);\n}\n\n.tv-card-location-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.tv-card-city {\n  font-size: 2rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.2;\n}\n\n.tv-location-card.medium .tv-card-city {\n  font-size: 1.3rem;\n}\n\n.tv-location-card.compact .tv-card-city {\n  font-size: 1.1rem;\n}\n\n.tv-card-country {\n  font-size: 1rem;\n  color: var(--text-muted);\n}\n\n.tv-location-card.compact .tv-card-country {\n  font-size: 0.8rem;\n}\n\n.tv-card-times {\n  display: flex;\n  gap: var(--spacing-lg);\n}\n\n.tv-card-sun {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n/* Main Weather */\n.tv-card-main {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: var(--spacing-xl);\n}\n\n.tv-location-card.compact .tv-card-main {\n  margin-bottom: var(--spacing-md);\n}\n\n.tv-card-temp-section {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.tv-card-icon {\n  width: 150px;\n  height: 150px;\n}\n\n.tv-location-card.medium .tv-card-icon {\n  width: 70px;\n  height: 70px;\n}\n\n.tv-location-card.compact .tv-card-icon {\n  width: 60px;\n  height: 60px;\n}\n\n.tv-card-temp-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.tv-card-temp {\n  font-size: 6rem;\n  font-weight: 200;\n  color: var(--text-primary);\n  line-height: 1;\n}\n\n.tv-location-card.medium .tv-card-temp {\n  font-size: 3rem;\n}\n\n.tv-location-card.compact .tv-card-temp {\n  font-size: 2.5rem;\n}\n\n.tv-card-temp-unit {\n  font-size: 2rem;\n  color: var(--text-secondary);\n  vertical-align: top;\n}\n\n.tv-location-card.medium .tv-card-temp-unit {\n  font-size: 1.5rem;\n}\n\n.tv-location-card.compact .tv-card-temp-unit {\n  font-size: 1rem;\n}\n\n.tv-card-feels {\n  font-size: 1.2rem;\n  color: var(--text-muted);\n  margin-top: var(--spacing-sm);\n}\n\n.tv-location-card.compact .tv-card-feels {\n  font-size: 0.8rem;\n}\n\n.tv-card-condition {\n  font-size: 1.5rem;\n  color: var(--text-secondary);\n  text-transform: capitalize;\n  margin-top: var(--spacing-md);\n}\n\n.tv-location-card.medium .tv-card-condition {\n  font-size: 1.2rem;\n}\n\n.tv-location-card.compact .tv-card-condition {\n  font-size: 0.9rem;\n  margin-top: var(--spacing-xs);\n}\n\n/* Metrics */\n.tv-card-metrics {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--spacing-md);\n  padding: var(--spacing-lg);\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-lg);\n}\n\n.tv-location-card.medium .tv-card-metrics {\n  grid-template-columns: repeat(2, 1fr);\n  padding: var(--spacing-sm);\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-sm);\n}\n\n.tv-location-card.medium .tv-metric-value {\n  font-size: 0.95rem;\n}\n\n.tv-location-card.medium .tv-card-main {\n  margin-bottom: var(--spacing-md);\n}\n\n.tv-metric {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  color: var(--text-secondary);\n}\n\n.tv-metric-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.tv-metric-value {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.tv-location-card.medium .tv-metric-value {\n  font-size: 1.1rem;\n}\n\n.tv-metric-label {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n/* Compact Metrics */\n.tv-card-compact-metrics {\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-lg);\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  padding-top: var(--spacing-sm);\n  border-top: 1px solid var(--border-color);\n}\n\n.tv-card-compact-metrics span {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n/* Mini Forecast */\n.tv-card-mini-forecast {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--spacing-md);\n  padding: var(--spacing-lg);\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius-md);\n}\n\n.tv-mini-day {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-xs);\n  flex: 1;\n}\n\n.tv-mini-day-name {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.tv-mini-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.tv-mini-temps {\n  display: flex;\n  gap: var(--spacing-sm);\n  font-size: 1rem;\n}\n\n.tv-mini-high {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.tv-mini-low {\n  color: var(--text-muted);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
